import { useState, useEffect, useId } from 'react';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs/inputText';
import { TextArea } from 'ui/inputs/textArea';
import { FlexSpacer } from 'ui/flexSpacer';
import JSONTree from 'core/jsonTree';
import { GhostButton, BUTTON_SIZES } from 'ui/button';
import { UPDATE_CATALOG_ITEM_METHOD } from 'modules/catalogTable/constants';
import { getSampleDataFromJson } from 'modules/catalogFieldTypes/helpers';
import { NewFieldsTable } from 'modules/catalogFieldTypes/components/NewFieldsTable';
import { CatalogItemValueContainer } from './CatalogForm.styled';
import { getParsedJsonState } from './CatalogItemValueJsonUploader.utils';

// type Props = {
//   handleKeyChange: (*) => void,
//   handleValueChange: (*) => void,
//   handleJsonOnAdd: (*) => void,
//   handleJsonOnEdit: (*) => void,
//   handleJsonOnDelete: (*) => void,
//   tableKey: ?string,
//   tableValue: ?string,
//   isCatalogCollectionsFlagOn: boolean,
//   newFields: Array<*>,
// };

export const CatalogItemValueJsonUploader = ({
  handleKeyChange,
  handleValueChange,
  handleJsonOnAdd,
  handleJsonOnEdit,
  handleJsonOnDelete,
  tableKey,
  tableValue,
  isCatalogCollectionsFlagOn,
  newFields,
}) => {
  const [useTextArea, setUseTextArea] = useState(false);
  const [isJsonValid, setIsJsonValid] = useState(true);
  const [jsonTableValue, setJsonTableValue] = useState(tableValue);
  const keyFieldId = useId();

  useEffect(() => {
    const updatedValues = getParsedJsonState(tableValue);
    setIsJsonValid(updatedValues.isJsonValid);
    setJsonTableValue(updatedValues.jsonTableValue);
  }, [tableValue]);

  const valueText = useTextArea ? 'Use JSON Editor' : 'Use TextArea';
  return (
    <CatalogItemValueContainer>
      <FlexSpacer flexDirection="column" alignItems="stretch">
        <FormField inputId={keyFieldId} labelText={'Key'}>
          <InputText
            data-test="catalog-json-key-input"
            id={keyFieldId}
            onChange={handleKeyChange}
            value={tableKey}
          />
        </FormField>
        <FormField
          labelText="Value"
          hasError={!isJsonValid}
          errorText="JSON is not valid"
          restrictionText={
            <GhostButton
              onClick={() => setUseTextArea((state) => !state)}
              size={BUTTON_SIZES.SMALL}
            >
              {valueText}
            </GhostButton>
          }
        >
          {useTextArea ? (
            <TextArea
              data-test="catalog-json-text-area"
              onChange={handleValueChange}
              value={tableValue}
            />
          ) : (
            <div className="catalog-jsonViewerWrapper">
              <JSONTree
                displayDataTypes={false}
                enableClipboard={false}
                src={jsonTableValue}
                rootName={null}
                onEdit={handleJsonOnEdit}
                onAdd={handleJsonOnAdd}
                onDelete={handleJsonOnDelete}
              />
            </div>
          )}
        </FormField>
        {isCatalogCollectionsFlagOn && newFields.length > 0 && (
          <NewFieldsTable
            rowData={getSampleDataFromJson({ newFields, tableValue })}
            updateMethod={UPDATE_CATALOG_ITEM_METHOD.JSON}
          />
        )}
      </FlexSpacer>
    </CatalogItemValueContainer>
  );
};
